export default __webpack_public_path__ + "static/media/instagram-logo-bold.6a80b325.svg";